import clsx from "clsx";

type Props = {
  progress: number;
};

function Pipe({ isOdd }: { isOdd: boolean }) {
  return <div className={clsx("w-px h-2.5", isOdd ? "bg-white/15" : "bg-white/30")} />;
}

export default function BusinessProgressBar({ progress = 0 }: Props) {
  const pipes = Array.from({ length: 62 }, (_, i) => ({
    id: `pipe-${i}`,
    isOdd: i % 2 !== 0,
  }));

  return (
    <div className="mb-3.5">
      <div className="h-12.5 p-[0.3125rem] border border-[#191919] rounded-2xl">
        <div className="relative flex h-10">
          <div
            className={clsx(
              "h-10 bg-gradient-lightBlue [--bg-angle:-90deg]",
              progress === 100 ? "rounded-xl" : "rounded-tl-xl rounded-bl-xl",
            )}
            style={{ width: `${progress}%` }}
          />
          <div
            className="relative z-1 h-10 bg-dark-800/50 rounded-tr-xl rounded-br-xl"
            style={{ width: `${100 - progress}%` }}
          />
          <div
            className={clsx(
              "absolute z-2 -top-0.5 w-[0.1875rem] h-11 bg-accent-muted brightness-110 rounded-[0.125rem] -translate-x-1/2",
              progress === 0 || progress === 100 ? "opacity-0" : "opacity-100",
            )}
            style={{ left: `${progress}%` }}
          />
          <div className="absolute top-0 left-0 flex items-center size-full px-3.5 space-x-2.5">
            {pipes.map(({ id, isOdd }) => (
              <Pipe key={id} isOdd={isOdd} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
